/**
 * Header - Portal header matching therapist style
 * 
 * Simple header with logo and burger menu for mobile.
 * Help and logout are in the sidebar menu.
 */
import React, { useContext } from "react";
import { Row, Col } from "react-bootstrap";
import useMediaQuery from "@mui/material/useMediaQuery";
import { BrandingContext } from "@shared/branding/BrandingContext";
import "./Header.css";

const Header = ({ onBurgerClick }) => {
  const { applicationImagePath } = useContext(BrandingContext);
  const isMobile = useMediaQuery("(max-width:900px)");

  // Mobile layout with burger menu
  if (isMobile) {
    return (
      <Row className="app-header no-padding">
        {/* Burger menu button - first item */}
        <Col xs="auto" className="mobile-burger-container">
          <button
            className="mobile-burger-button"
            onClick={onBurgerClick}
            aria-label="Open menu"
          >
            <div className="burger-line"></div>
            <div className="burger-line"></div>
            <div className="burger-line"></div>
          </button>
        </Col>

        {/* Spacer */}
        <Col xs className="searchbar-container">
          {/* Empty spacer for mobile */}
        </Col>

        {/* Logo/emblem - last item */}
        <Col xs="auto" className="app-header-image">
          <a href="/">
            <img
              src={applicationImagePath}
              alt="Logo"
              className="app-header-image-class"
            />
          </a>
        </Col>
      </Row>
    );
  }

  // Desktop layout
  return (
    <Row className="app-header no-padding">
      <Col xs="auto" className="app-header-image">
        <a href="/">
          <img
            src={applicationImagePath}
            alt="Logo"
            className="app-header-image-class"
          />
        </a>
      </Col>

      {/* Empty spacer column - matches therapist layout structure */}
      <Col xs className="searchbar-container">
        {/* No search bar in portal, but keeps consistent layout */}
      </Col>
    </Row>
  );
};

export default Header;

